import { staffAuditPageSchema, staffNotificationFailurePageSchema, staffPaymentExceptionListSchema, staffResolvePaymentExceptionOutcomeSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
/** The query text of an audit or failure page. An absent key is left out. */
function queryOf(input) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(input ?? {})) {
        if (value === undefined || value === null || value === "")
            continue;
        params.set(key, value instanceof Date ? value.toISOString() : String(value));
    }
    return params;
}
export function createStaffDiagnosticsApi(options) {
    const send = createMemoryTransport(options);
    return {
        listAuditEvents: (query, o) => send({
            method: "GET",
            path: "/staff/audit/events",
            query: queryOf(query),
            schema: staffAuditPageSchema,
            signal: o?.signal,
        }),
        listNotificationFailures: (query, o) => send({
            method: "GET",
            path: "/staff/operations/notification-failures",
            query: queryOf(query),
            schema: staffNotificationFailurePageSchema,
            signal: o?.signal,
        }),
        listPaymentExceptions: (o) => send({
            method: "GET",
            path: "/staff/payment-exceptions",
            schema: staffPaymentExceptionListSchema,
            signal: o?.signal,
        }),
        resolvePaymentException: (exceptionId, body, o) => send({
            method: "POST",
            path: `/staff/payment-exceptions/${encodeURIComponent(exceptionId)}/resolve`,
            body,
            schema: staffResolvePaymentExceptionOutcomeSchema,
            idempotencyKey: o?.idempotencyKey,
            signal: o?.signal,
        }),
    };
}
